import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventModel, PairGameScore, PeriodGameScore, SetGameScore, SnookerScore } from '@frontend/sports/betting-offer/feature/model';

@Component({
    selector: 'ms-pair-game-scoreboard',
    templateUrl: 'pair-game-scoreboard.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf],
})
export class PairGameScoreboardComponent {
    @Input() event: EventModel;

    get score(): PairGameScore {
        const score = this.event.scoreboard.score;

        if (score instanceof PeriodGameScore) {
            return this.getPairGameScore(score.participant1.total, score.participant2.total);
        }

        if (score instanceof SetGameScore && this.event.isBaseballGame()) {
            return this.getPairGameScore(score.participant1.points! || 0, score.participant2.points! || 0);
        }

        if (score instanceof SetGameScore) {
            return this.getPairGameScore(score.participant1.r! || 0, score.participant2.r! || 0);
        }

        if (score instanceof SnookerScore) {
            return this.getPairGameScore(score.frames.participant1, score.frames.participant2);
        }

        return score as PairGameScore;
    }

    private getPairGameScore(player1Score: any, player2Score: any): PairGameScore {
        const score = new PairGameScore();
        score.participant1 = player1Score;
        score.participant2 = player2Score;

        return score;
    }
}
